export enum HsToolActionType {
  None,
  Move,
  Scale,
  Rotate,
}
